import React, {useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {SActionBtn, SBack, SIDRender, SLowcodeList, SMessage, STableActions} from "shj-components";

import UrlConfig from "@/api/UrlConfigs.ts";
import {
  findBuildingPage,
  getCustomerSource,
  getTrackPlanPage,
  getTrackPlanReceive
} from "@/services/customerServices.ts";
import CheckThePhone from "@/components/CheckThePhone";
import config from "./config.ts";
import {apiData2Table} from "@/utils/data.ts";
import {message, Select} from "antd";
import useGlobalStore from "@/store";
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import DebounceSearchSelect from "@/pages/baseProduct/components/DebounceSearchSelect";
import {getEmployeeSearchByOrgIdList} from "@/services/channelManagement.ts";
import {filterSerchData} from "@/utils/common.ts";

export default function (){
  const globalUser = useGlobalStore((state: any) => state.user)
  const navigate = useNavigate()
  const listRef = useRef()
  const [personList, setPersonList] = useState([])

  // 表格加载
  const fetchList = ({ current, pageSize, query }) => {
    return new Promise((resolve, reject) => {
      const params = filterSerchData(query, ['createdTime'], ['StartWith', 'endWith'])
      const params_ = filterSerchData(params, ['invalidTime'])
      try {
        getTrackPlanPage({
          params: {pageId: current, pageSize},
          data: {...params_, queryExtendFlag: true, publicSeaFlag: true}}
        ).then((res)=>{
          resolve(apiData2Table(res))
        }).catch(reject)
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  const onChangeOrg = (orgId) => {
    listRef.current?.updateSearchData('leader', [])
    getPersonList(orgId)
  }

  const getPersonList = (orgId) => {
    getEmployeeSearchByOrgIdList(orgId).then(res => {
      setPersonList(res)
    })
  }

  const onDetail = ({id, customerId, statusName}) => {
    navigate('/customerManage/publicInformation/details/' + id + '/' + customerId, { state: { statusName } })
  }

  const onReceive = (record) => {
    SMessage.confirm({
      title: '是否确认领取',
      content: null,
      onOk: () => {
        const deptPosition = globalUser?.currentDepartmentPosition?.department || {}
        const obj = {
          trackPlanId: record.id,
          userDto: {
            ucenterUserId: globalUser.id,
            name: globalUser.name,
            deptId: deptPosition.id,
            deptName: deptPosition.name,
            companyId: deptPosition.company?.id,
            companyName: deptPosition.company?.name,
          }
        }
        return getTrackPlanReceive(obj).then(res=>{
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const getStatusOptions = () => {
    return new Promise(async resolve => {
    const channel = await getCustomerSource()
    const companyList = await httpOrgList()
    const houseNatureEnums = await getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.HouseNatureEnum');
    const trackPlanStatusEnums = await getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.TrackPlanStatusEnum');
      resolve({
        channel,
        companyList,
        houseNatureEnums,
        trackPlanStatusEnums,
        memberFlagList: [{
          label: '是',
          value: true,
        },{
          label: '否',
          value: false,
        }]
      })
    })
  }

  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onChangeOrg },
    customRender: {
      checkPhone(text: any, re: any) {
        return <CheckThePhone initValue={text} url={`${UrlConfig.PlusCrmWeb.TrackPlanViewPhone}/${re?.id}`}
                              showValue={'idCard'}
                              type="GET"/>
      },
      renderOperate(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onDetail(record)}> 详情 </SActionBtn>
            <SActionBtn onClick={() => onReceive(record)}> 领取 </SActionBtn>
          </STableActions>
        )
      },
      buildRender({name, form}){
        return <DebounceSearchSelect label={'楼盘'} nameKey={'nameLike'} fetchOptions={findBuildingPage} onChange={(v) => form.setFieldsValue({[name]: v})}/>
      },
      personRender({key, form}){
        return <Select options={personList}
                       placeholder={`请选择`}
                       fieldNames={{label: 'userName', value: 'id'}}
                       onChange={(v) => form.setFieldsValue({[key]: v})}/>
      },
    },
  }

  return <div>
    <SBack title="公海池"></SBack>
    <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
  </div>
}